// removed by extract-text-webpack-plugin
module.exports = {"header":"app-2lrWtG8R","pageHeaderContent":"app-96UKxYQM","contentLink":"app-3kSrt7P2"};


//////////////////
// WEBPACK FOOTER
// ./src/wbap-unit-app/wbap-dashboard-dailyPrice/style.less
// module id = 873
// module chunks = 0